import axios, { AxiosResponse } from "axios"
import { strippedString } from "../strippedString"
import { getWebSiteUrlFromWindow } from "../../url/getWebSiteUrlFromWindow"
import { PaymentData } from "../../../config/payments"
import { CourseType, CourseVariant } from "../../prismic/Course"
import { emailInlineHTML } from "../emailInlineHtml"
import { RegisterStudentCourse } from "../../../components/RegisterModal/types"
import { SendEmail } from "../SendEmail"
import { emailDefinition1RegisterIntoOnlineCourse } from "../definitions/emailDefinition1RegisterIntoOnlineCourse"
import { emailDefinition1RegisterIntoOnlineProjectDays } from "../definitions/emailDefinition1RegisterIntoOnlineProjectDays"
import { emailDefinition1RegisterIntoOnlineSampleCourse } from "../definitions/emailDefinition1RegisterIntoOnlineSampleCourse"
import { logosEmailAttachments } from "../definitions/subDefinitions/logosEmailAttachments"
import { MappedCourse } from "../../prismic/MappedCourse"
import { generateEmailCourseListOfferOnClient } from "../definitions/subDefinitions/generateEmailCourseListOffer"
import { emailDefinition1RegisterIntoOnlineFreeCourse } from "../definitions/emailDefinition1RegisterIntoOnlineFreeCourse"
import { emailDefinition1RegisterIntoInPersonFreeCourse } from "../definitions/emailDefinition1RegisterIntoInPersonFreeCourse"

export const registrationEmailUtmParameters = "?utm_source=cta&utm_medium=email&utm_campaign=course-registration-email"

const getEmailLetterByCourseVariant = (
  course: MappedCourse,
  courseDetailPageUrl: string,
  equipmentBuyFromOrganization: boolean,
  paymentData: PaymentData,
  technologyPageUrl: string,
  courseListOffer: string,
  downloadPdfVoucherUrl?: string
): { body: string; subject: string } => {
  switch (true) {
    case course.courseVariant === CourseVariant.projectDays:
      return emailDefinition1RegisterIntoOnlineProjectDays(course.name, course.whenAsString, courseDetailPageUrl, downloadPdfVoucherUrl)
    case course.courseVariant === CourseVariant.sampleCourse:
      return emailDefinition1RegisterIntoOnlineSampleCourse(
        course.name,
        course.whenAsString,
        courseDetailPageUrl,
        technologyPageUrl,
        courseListOffer,
        downloadPdfVoucherUrl
      )
    case (course.type === CourseType.inPerson || course.type === CourseType.inPersonEvent) &&
      paymentData.amount.value === 0 &&
      (course.price === 0 || !course.price):
      return emailDefinition1RegisterIntoInPersonFreeCourse(course.name, course.whenAsString, courseDetailPageUrl, courseListOffer, downloadPdfVoucherUrl)
    case course.type === CourseType.online && paymentData.amount.value === 0 && (course.price === 0 || !course.price):
      return emailDefinition1RegisterIntoOnlineFreeCourse(course.name, course.whenAsString, courseDetailPageUrl, courseListOffer, downloadPdfVoucherUrl)
    default:
      return emailDefinition1RegisterIntoOnlineCourse(
        course.name,
        course.whenAsString,
        courseDetailPageUrl,
        equipmentBuyFromOrganization,
        paymentData,
        courseListOffer,
        downloadPdfVoucherUrl
      )
  }
}

export const sendRegisterEmail = async (
  values: RegisterStudentCourse,
  course: MappedCourse,
  paymentData: PaymentData,
  recipients: string[],
  registrationId: number,
  onError?: (e: any) => void
): Promise<void | AxiosResponse> => {
  const webUrl = getWebSiteUrlFromWindow() || "https://vzdelanibudoucnosti.cz"
  const courseDetailPageUrl = `${webUrl}${course.registerUrl}`
  const downloadPdfVoucherUrl: string | undefined = values.withGiftVoucher ? `${webUrl}/pdf/voucher?id=${registrationId}` : undefined
  const technologyPageUrl = `${webUrl}${course.technologyUrl}`
  const courseListOffer = await generateEmailCourseListOfferOnClient(course.slug)

  const { body, subject } = getEmailLetterByCourseVariant(
    course,
    courseDetailPageUrl,
    !!values.equipmentBuyFromOrganization,
    paymentData,
    technologyPageUrl,
    courseListOffer,
    downloadPdfVoucherUrl
  )

  const config: SendEmail = {
    emailList: recipients,
    html: emailInlineHTML(subject, course.name, body),
    text: strippedString(body),
    subject,
    attachments: [...logosEmailAttachments],
    emailNotificationSubType: values.withGiftVoucher ? "with PDF voucher link" : undefined
  }

  return await axios
    .post("/api/email/send", config)
    .catch((err) => {
      console.error("sendRegisterEmail", err)
      onError && onError(err)
    })
    .then((res) => res)
}
